export default __webpack_public_path__ + "7bd3afcbeb054a9d0777826e860c9167.png";